<template lang="html">
  <!-- Footer -->
  <footer class="page-footer font-small blue">
    <!-- Copyright -->
    <div class="footer-copyright text-center py-3">
      <p class="small">
        <strong>UkeAbility.org</strong> by Joe Weiss, with support from
        <a href="http://tungite.com">Tungite Labs</a>. 2018-2022.
      </p>
    </div>
    <!-- Copyright -->
  </footer>
  <!-- Footer -->
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="css" scoped></style>
